export const locale = {
    lang: 'th',
    data: {
        NAV: {
            APPLICATIONS: 'Applications',
            LIST_SALE: {
                TITLE: 'รายการข้อมูลผู้สมัคร'
            },
            DASHBOARD: {
                TITLE: 'หน้าหลัก'
            }
        }
    }
};
